import Home from './Home/Home.vue';
import Registro from './Registro/Registro.vue';
import Olvido from './Registro/Olvido.vue';

import Terminos from './TerminosYCondiciones/TerminosYCondiciones.vue';


import Dashboard from './Dashboard/Dashboard.vue';

/*Alumnos admin*/
import Alumnos from './Dashboard/Alumnos/Alumnos.vue';
import AlumnosAlta from './Dashboard/Alumnos/Alta.vue';
import AlumnosEdicion from './Dashboard/Alumnos/Edicion.vue';
import AlumnosGrupo from './Dashboard/Alumnos/Grupo.vue';

/*Docentes admin*/
import Docentes from './Dashboard/Docentes/Docentes.vue';
import DocentesAlta from './Dashboard/Docentes/Alta.vue';
import DocentesEdicion from './Dashboard/Docentes/Edicion.vue';
import DocentesGrupo from './Dashboard/Docentes/Grupo.vue';

/*Programas admin*/
import Programas from './Dashboard/Programas/Programas.vue';
import ProgramasAlta from './Dashboard/Programas/Alta.vue';
import ProgramasEdicion from './Dashboard/Programas/Edicion.vue';

/*Asignaturas admin*/
import Asignaturas from './Dashboard/Asignaturas/Asignaturas.vue';
import AsignaturasAlta from './Dashboard/Asignaturas/Alta.vue';
import AsignaturasEdicion from './Dashboard/Asignaturas/Edicion.vue';

/*Grupos admin*/
import Grupos from './Dashboard/Grupos/Grupos.vue';
import GruposAlta from './Dashboard/Grupos/Alta.vue';
import GruposEdicion from './Dashboard/Grupos/Edicion.vue';
import GruposConfiguracion from './Dashboard/Grupos/Configuracion.vue';


/*Alumnos*/
import AlumnosGrupos from './Alumnos/Grupos.vue';
import AlumnosCalendario from './Alumnos/Calendario/Calendario.vue';
import AlumnosManuales from './Alumnos/Manuales/Manuales.vue';
import AlumnosReglamento from './Alumnos/Reglamento/Reglamento.vue';
import AlumnosComunicate from './Alumnos/Comunicate/Comunicate.vue';
import AlumnosCalificaciones from './Alumnos/Grupos/Calificaciones.vue';

/*Docentes*/
import DocentesAsignaturas from './Docentes/Asignaturas.vue';
import DocentesCalendario from './Docentes/Calendario/Calendario.vue';
import DocentesManuales from './Docentes/Manuales/Manuales.vue';
import DocentesReglamento from './Docentes/Reglamento/Reglamento.vue';


/*Egresados*/
import EgresadosEstatus from './Egresados/Estatus.vue';
import EgresadosCalendario from './Egresados/Calendario/Calendario.vue';
import EgresadosManuales from './Egresados/Manuales/Manuales.vue';
import EgresadosReglamento from './Egresados/Reglamento/Reglamento.vue';
import EgresadosActualizacion from './Egresados/Actualizacion/Actualizacion.vue';
import EgresadosCalificaciones from './Egresados/Grupos/Calificaciones.vue';



import cookie from 'vue-cookie';

export const routes = [
    { path: '', component: Home },
    { path: '/', component: Home },

    /*{ path: '/registro', component: Registro },
    { path: '/recuperacion', component: Olvido },*/

    { path: '/dashboard/', component: Dashboard, beforeEnter(to, from, next) { protectAdministrador(next) } },

    { path: '/dashboard/alumnos', component: Alumnos, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/alumnos/alta', component: AlumnosAlta, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/alumnos/edicion/:matricula', component: AlumnosEdicion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/alumnos/grupo/:id_grupo/:matricula', component: AlumnosGrupo, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },


    { path: '/dashboard/docentes', component: Docentes, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/docentes/alta', component: DocentesAlta, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/docentes/edicion/:matricula', component: DocentesEdicion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/docentes/grupo/:id_grupo/:matricula', component: DocentesGrupo, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },

    { path: '/dashboard/programas', component: Programas, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/programas/alta', component: ProgramasAlta, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/programas/edicion/:no_acuerdo', component: ProgramasEdicion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },

    { path: '/dashboard/asignaturas', component: Asignaturas, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/asignaturas/alta', component: AsignaturasAlta, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/asignaturas/edicion/:codigo/:clave', component: AsignaturasEdicion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },

    { path: '/dashboard/grupos', component: Grupos, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/grupos/alta', component: GruposAlta, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/grupos/edicion/:id_grupo/:numero', component: GruposEdicion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/dashboard/grupos/configuracion/:id_grupo/:numero', component: GruposConfiguracion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },


    /*{ path: '/terminos-y-condiciones', component: Terminos },
    { path: '/aviso-de-privacidad', component: Terminos },*/

    { path: '/alumnos/calificaciones', component: AlumnosGrupos, beforeEnter(to, from, next) { protectAlumno(next) } },
    { path: '/alumnos/calificaciones/:id_grupo/:matricula', component: AlumnosCalificaciones, props: true, beforeEnter(to, from, next) { protectAlumno(next) } },
    { path: '/alumnos/calendario', component: AlumnosCalendario, beforeEnter(to, from, next) { protectAlumno(next) } },
    { path: '/alumnos/manuales', component: AlumnosManuales, beforeEnter(to, from, next) { protectAlumno(next) } },
    { path: '/alumnos/reglamento', component: AlumnosReglamento, beforeEnter(to, from, next) { protectAlumno(next) } },
    { path: '/alumnos/comunicate', component: AlumnosComunicate, beforeEnter(to, from, next) { protectAlumno(next) } },

    { path: '/docentes/asignaturas', component: DocentesAsignaturas, beforeEnter(to, from, next) { protectDocente(next) } },
    { path: '/docentes/calendario', component: DocentesCalendario, beforeEnter(to, from, next) { protectDocente(next) } },
    { path: '/docentes/manuales', component: DocentesManuales, beforeEnter(to, from, next) { protectDocente(next) } },
    { path: '/docentes/reglamento', component: DocentesReglamento, beforeEnter(to, from, next) { protectDocente(next) } },

    { path: '/egresados/estatus', component: EgresadosEstatus, beforeEnter(to, from, next) { protectEgresado(next) } },
    { path: '/egresados/estatus/:id_grupo/:matricula', component: EgresadosCalificaciones, props: true, beforeEnter(to, from, next) { protectEgresado(next) } },
    { path: '/egresados/calendario', component: EgresadosCalendario, beforeEnter(to, from, next) { protectEgresado(next) } },
    { path: '/egresados/manuales', component: EgresadosManuales, beforeEnter(to, from, next) { protectEgresado(next) } },
    { path: '/egresados/reglamento', component: EgresadosReglamento, beforeEnter(to, from, next) { protectEgresado(next) } },
    { path: '/egresados/actualizacion', component: EgresadosActualizacion, beforeEnter(to, from, next) { protectEgresado(next) } },

];


function protectAdministrador(next) {
    if (cookie.get('useriee') != null) {
        var user_level = Object(JSON.parse(cookie.get('useriee')).user_level);
        if (cookie.get('useriee') != null && user_level == 7) {
            next();
        } else {
            cookie.delete("useriee");
            next('/');
        }
    } else {
        next('/');
    }
}

function protectAlumno(next) {
    if (cookie.get('useriee') != null) {
        var user_level = Object(JSON.parse(cookie.get('useriee')).user_level);
        if (cookie.get('useriee') != null && (user_level == 1)) {
            next();
        } else {
            cookie.delete("useriee");
            next('/');
        }
    } else {
        next('/');
    }

}

function protectEgresado(next) {
    if (cookie.get('useriee') != null) {
        var user_level = Object(JSON.parse(cookie.get('useriee')).user_level);
        if (cookie.get('useriee') != null && (user_level == 2)) {
            next();
        } else {
            cookie.delete("useriee");
            next('/');
        }
    } else {
        next('/');
    }
}

function protectDocente(next) {
    if (cookie.get('useriee') != null) {
        var user_level = Object(JSON.parse(cookie.get('useriee')).user_level);
        if (cookie.get('useriee') != null && user_level == 5) {
            next();
        } else {
            cookie.delete("useriee");
            next('/');
        }
    } else {
        next('/');
    }
}